/*! For license information please see react-typed-component.js.LICENSE.txt */
!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react")) : "function" == typeof define && define.amd ? define(["react"], e) : "object" == typeof exports ? exports["react-typed-component"] = e(require("react")) : t["react-typed-component"] = e(t.React);
}(this, function (t) {
  return function () {
    var e = {
      703: function _(t, e, n) {
        "use strict";

        var r = n(414);

        function s() {}

        function o() {}

        o.resetWarningCache = s, t.exports = function () {
          function t(t, e, n, s, o, i) {
            if (i !== r) {
              var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
              throw a.name = "Invariant Violation", a;
            }
          }

          function e() {
            return t;
          }

          t.isRequired = t;
          var n = {
            array: t,
            bigint: t,
            bool: t,
            func: t,
            number: t,
            object: t,
            string: t,
            symbol: t,
            any: t,
            arrayOf: e,
            element: t,
            elementType: t,
            instanceOf: e,
            node: t,
            objectOf: e,
            oneOf: e,
            oneOfType: e,
            shape: e,
            exact: e,
            checkPropTypes: o,
            resetWarningCache: s
          };
          return n.PropTypes = n, n;
        };
      },
      697: function _(t, e, n) {
        t.exports = n(703)();
      },
      414: function _(t) {
        "use strict";

        t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      },
      614: function _(t) {
        var e;
        e = function e() {
          return function (t) {
            var e = {};

            function n(r) {
              if (e[r]) return e[r].exports;
              var s = e[r] = {
                exports: {},
                id: r,
                loaded: !1
              };
              return t[r].call(s.exports, s, s.exports, n), s.loaded = !0, s.exports;
            }

            return n.m = t, n.c = e, n.p = "", n(0);
          }([function (t, e, n) {
            "use strict";

            Object.defineProperty(e, "__esModule", {
              value: !0
            });

            var r = function () {
              function t(t, e) {
                for (var n = 0; n < e.length; n++) {
                  var r = e[n];
                  r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
              }

              return function (e, n, r) {
                return n && t(e.prototype, n), r && t(e, r), e;
              };
            }(),
                s = n(1),
                o = n(3),
                i = function () {
              function t(e, n) {
                !function (t, e) {
                  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), s.initializer.load(this, n, e), this.begin();
              }

              return r(t, [{
                key: "toggle",
                value: function value() {
                  this.pause.status ? this.start() : this.stop();
                }
              }, {
                key: "stop",
                value: function value() {
                  this.typingComplete || this.pause.status || (this.toggleBlinking(!0), this.pause.status = !0, this.options.onStop(this.arrayPos, this));
                }
              }, {
                key: "start",
                value: function value() {
                  this.typingComplete || this.pause.status && (this.pause.status = !1, this.pause.typewrite ? this.typewrite(this.pause.curString, this.pause.curStrPos) : this.backspace(this.pause.curString, this.pause.curStrPos), this.options.onStart(this.arrayPos, this));
                }
              }, {
                key: "destroy",
                value: function value() {
                  this.reset(!1), this.options.onDestroy(this);
                }
              }, {
                key: "reset",
                value: function value() {
                  var t = arguments.length <= 0 || void 0 === arguments[0] || arguments[0];
                  clearInterval(this.timeout), this.replaceText(""), this.cursor && this.cursor.parentNode && (this.cursor.parentNode.removeChild(this.cursor), this.cursor = null), this.strPos = 0, this.arrayPos = 0, this.curLoop = 0, t && (this.insertCursor(), this.options.onReset(this), this.begin());
                }
              }, {
                key: "begin",
                value: function value() {
                  var t = this;
                  this.options.onBegin(this), this.typingComplete = !1, this.shuffleStringsIfNeeded(this), this.insertCursor(), this.bindInputFocusEvents && this.bindFocusEvents(), this.timeout = setTimeout(function () {
                    t.currentElContent && 0 !== t.currentElContent.length ? t.backspace(t.currentElContent, t.currentElContent.length) : t.typewrite(t.strings[t.sequence[t.arrayPos]], t.strPos);
                  }, this.startDelay);
                }
              }, {
                key: "typewrite",
                value: function value(t, e) {
                  var n = this;
                  this.fadeOut && this.el.classList.contains(this.fadeOutClass) && (this.el.classList.remove(this.fadeOutClass), this.cursor && this.cursor.classList.remove(this.fadeOutClass));
                  var r = this.humanizer(this.typeSpeed),
                      s = 1;
                  !0 !== this.pause.status ? this.timeout = setTimeout(function () {
                    e = o.htmlParser.typeHtmlChars(t, e, n);
                    var r = 0,
                        i = t.substr(e);

                    if ("^" === i.charAt(0) && /^\^\d+/.test(i)) {
                      var a = 1;
                      a += (i = /\d+/.exec(i)[0]).length, r = parseInt(i), n.temporaryPause = !0, n.options.onTypingPaused(n.arrayPos, n), t = t.substring(0, e) + t.substring(e + a), n.toggleBlinking(!0);
                    }

                    if ("`" === i.charAt(0)) {
                      for (; "`" !== t.substr(e + s).charAt(0) && (s++, !(e + s > t.length));) {
                        ;
                      }

                      var u = t.substring(0, e),
                          c = t.substring(u.length + 1, e + s),
                          p = t.substring(e + s + 1);
                      t = u + c + p, s--;
                    }

                    n.timeout = setTimeout(function () {
                      n.toggleBlinking(!1), e >= t.length ? n.doneTyping(t, e) : n.keepTyping(t, e, s), n.temporaryPause && (n.temporaryPause = !1, n.options.onTypingResumed(n.arrayPos, n));
                    }, r);
                  }, r) : this.setPauseStatus(t, e, !0);
                }
              }, {
                key: "keepTyping",
                value: function value(t, e, n) {
                  0 === e && (this.toggleBlinking(!1), this.options.preStringTyped(this.arrayPos, this)), e += n;
                  var r = t.substr(0, e);
                  this.replaceText(r), this.typewrite(t, e);
                }
              }, {
                key: "doneTyping",
                value: function value(t, e) {
                  var n = this;
                  this.options.onStringTyped(this.arrayPos, this), this.toggleBlinking(!0), this.arrayPos === this.strings.length - 1 && (this.complete(), !1 === this.loop || this.curLoop === this.loopCount) || (this.timeout = setTimeout(function () {
                    n.backspace(t, e);
                  }, this.backDelay));
                }
              }, {
                key: "backspace",
                value: function value(t, e) {
                  var n = this;

                  if (!0 !== this.pause.status) {
                    if (this.fadeOut) return this.initFadeOut();
                    this.toggleBlinking(!1);
                    var r = this.humanizer(this.backSpeed);
                    this.timeout = setTimeout(function () {
                      e = o.htmlParser.backSpaceHtmlChars(t, e, n);
                      var r = t.substr(0, e);

                      if (n.replaceText(r), n.smartBackspace) {
                        var s = n.strings[n.arrayPos + 1];
                        s && r === s.substr(0, e) ? n.stopNum = e : n.stopNum = 0;
                      }

                      e > n.stopNum ? (e--, n.backspace(t, e)) : e <= n.stopNum && (n.arrayPos++, n.arrayPos === n.strings.length ? (n.arrayPos = 0, n.options.onLastStringBackspaced(), n.shuffleStringsIfNeeded(), n.begin()) : n.typewrite(n.strings[n.sequence[n.arrayPos]], e));
                    }, r);
                  } else this.setPauseStatus(t, e, !1);
                }
              }, {
                key: "complete",
                value: function value() {
                  this.options.onComplete(this), this.loop ? this.curLoop++ : this.typingComplete = !0;
                }
              }, {
                key: "setPauseStatus",
                value: function value(t, e, n) {
                  this.pause.typewrite = n, this.pause.curString = t, this.pause.curStrPos = e;
                }
              }, {
                key: "toggleBlinking",
                value: function value(t) {
                  this.cursor && (this.pause.status || this.cursorBlinking !== t && (this.cursorBlinking = t, t ? this.cursor.classList.add("typed-cursor--blink") : this.cursor.classList.remove("typed-cursor--blink")));
                }
              }, {
                key: "humanizer",
                value: function value(t) {
                  return Math.round(Math.random() * t / 2) + t;
                }
              }, {
                key: "shuffleStringsIfNeeded",
                value: function value() {
                  this.shuffle && (this.sequence = this.sequence.sort(function () {
                    return Math.random() - .5;
                  }));
                }
              }, {
                key: "initFadeOut",
                value: function value() {
                  var t = this;
                  return this.el.className += " " + this.fadeOutClass, this.cursor && (this.cursor.className += " " + this.fadeOutClass), setTimeout(function () {
                    t.arrayPos++, t.replaceText(""), t.strings.length > t.arrayPos ? t.typewrite(t.strings[t.sequence[t.arrayPos]], 0) : (t.typewrite(t.strings[0], 0), t.arrayPos = 0);
                  }, this.fadeOutDelay);
                }
              }, {
                key: "replaceText",
                value: function value(t) {
                  this.attr ? this.el.setAttribute(this.attr, t) : this.isInput ? this.el.value = t : "html" === this.contentType ? this.el.innerHTML = t : this.el.textContent = t;
                }
              }, {
                key: "bindFocusEvents",
                value: function value() {
                  var t = this;
                  this.isInput && (this.el.addEventListener("focus", function (e) {
                    t.stop();
                  }), this.el.addEventListener("blur", function (e) {
                    t.el.value && 0 !== t.el.value.length || t.start();
                  }));
                }
              }, {
                key: "insertCursor",
                value: function value() {
                  this.showCursor && (this.cursor || (this.cursor = document.createElement("span"), this.cursor.className = "typed-cursor", this.cursor.setAttribute("aria-hidden", !0), this.cursor.innerHTML = this.cursorChar, this.el.parentNode && this.el.parentNode.insertBefore(this.cursor, this.el.nextSibling)));
                }
              }]), t;
            }();

            e.default = i, t.exports = e.default;
          }, function (t, e, n) {
            "use strict";

            Object.defineProperty(e, "__esModule", {
              value: !0
            });

            var r,
                s = Object.assign || function (t) {
              for (var e = 1; e < arguments.length; e++) {
                var n = arguments[e];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
                }
              }

              return t;
            },
                o = function () {
              function t(t, e) {
                for (var n = 0; n < e.length; n++) {
                  var r = e[n];
                  r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
              }

              return function (e, n, r) {
                return n && t(e.prototype, n), r && t(e, r), e;
              };
            }(),
                i = (r = n(2)) && r.__esModule ? r : {
              default: r
            },
                a = function () {
              function t() {
                !function (t, e) {
                  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t);
              }

              return o(t, [{
                key: "load",
                value: function value(t, e, n) {
                  if (t.el = "string" == typeof n ? document.querySelector(n) : n, t.options = s({}, i.default, e), t.isInput = "input" === t.el.tagName.toLowerCase(), t.attr = t.options.attr, t.bindInputFocusEvents = t.options.bindInputFocusEvents, t.showCursor = !t.isInput && t.options.showCursor, t.cursorChar = t.options.cursorChar, t.cursorBlinking = !0, t.elContent = t.attr ? t.el.getAttribute(t.attr) : t.el.textContent, t.contentType = t.options.contentType, t.typeSpeed = t.options.typeSpeed, t.startDelay = t.options.startDelay, t.backSpeed = t.options.backSpeed, t.smartBackspace = t.options.smartBackspace, t.backDelay = t.options.backDelay, t.fadeOut = t.options.fadeOut, t.fadeOutClass = t.options.fadeOutClass, t.fadeOutDelay = t.options.fadeOutDelay, t.isPaused = !1, t.strings = t.options.strings.map(function (t) {
                    return t.trim();
                  }), "string" == typeof t.options.stringsElement ? t.stringsElement = document.querySelector(t.options.stringsElement) : t.stringsElement = t.options.stringsElement, t.stringsElement) {
                    t.strings = [], t.stringsElement.style.display = "none";
                    var r = Array.prototype.slice.apply(t.stringsElement.children),
                        o = r.length;
                    if (o) for (var a = 0; a < o; a += 1) {
                      var u = r[a];
                      t.strings.push(u.innerHTML.trim());
                    }
                  }

                  for (var a in t.strPos = 0, t.arrayPos = 0, t.stopNum = 0, t.loop = t.options.loop, t.loopCount = t.options.loopCount, t.curLoop = 0, t.shuffle = t.options.shuffle, t.sequence = [], t.pause = {
                    status: !1,
                    typewrite: !0,
                    curString: "",
                    curStrPos: 0
                  }, t.typingComplete = !1, t.strings) {
                    t.sequence[a] = a;
                  }

                  t.currentElContent = this.getCurrentElContent(t), t.autoInsertCss = t.options.autoInsertCss, this.appendAnimationCss(t);
                }
              }, {
                key: "getCurrentElContent",
                value: function value(t) {
                  return t.attr ? t.el.getAttribute(t.attr) : t.isInput ? t.el.value : "html" === t.contentType ? t.el.innerHTML : t.el.textContent;
                }
              }, {
                key: "appendAnimationCss",
                value: function value(t) {
                  var e = "data-typed-js-css";

                  if (t.autoInsertCss && (t.showCursor || t.fadeOut) && !document.querySelector("[" + e + "]")) {
                    var n = document.createElement("style");
                    n.type = "text/css", n.setAttribute(e, !0);
                    var r = "";
                    t.showCursor && (r += "\n        .typed-cursor{\n          opacity: 1;\n        }\n        .typed-cursor.typed-cursor--blink{\n          animation: typedjsBlink 0.7s infinite;\n          -webkit-animation: typedjsBlink 0.7s infinite;\n                  animation: typedjsBlink 0.7s infinite;\n        }\n        @keyframes typedjsBlink{\n          50% { opacity: 0.0; }\n        }\n        @-webkit-keyframes typedjsBlink{\n          0% { opacity: 1; }\n          50% { opacity: 0.0; }\n          100% { opacity: 1; }\n        }\n      "), t.fadeOut && (r += "\n        .typed-fade-out{\n          opacity: 0;\n          transition: opacity .25s;\n        }\n        .typed-cursor.typed-cursor--blink.typed-fade-out{\n          -webkit-animation: 0;\n          animation: 0;\n        }\n      "), 0 !== n.length && (n.innerHTML = r, document.body.appendChild(n));
                  }
                }
              }]), t;
            }();

            e.default = a;
            var u = new a();
            e.initializer = u;
          }, function (t, e) {
            "use strict";

            Object.defineProperty(e, "__esModule", {
              value: !0
            });
            e.default = {
              strings: ["These are the default values...", "You know what you should do?", "Use your own!", "Have a great day!"],
              stringsElement: null,
              typeSpeed: 0,
              startDelay: 0,
              backSpeed: 0,
              smartBackspace: !0,
              shuffle: !1,
              backDelay: 700,
              fadeOut: !1,
              fadeOutClass: "typed-fade-out",
              fadeOutDelay: 500,
              loop: !1,
              loopCount: 1 / 0,
              showCursor: !0,
              cursorChar: "|",
              autoInsertCss: !0,
              attr: null,
              bindInputFocusEvents: !1,
              contentType: "html",
              onBegin: function onBegin(t) {},
              onComplete: function onComplete(t) {},
              preStringTyped: function preStringTyped(t, e) {},
              onStringTyped: function onStringTyped(t, e) {},
              onLastStringBackspaced: function onLastStringBackspaced(t) {},
              onTypingPaused: function onTypingPaused(t, e) {},
              onTypingResumed: function onTypingResumed(t, e) {},
              onReset: function onReset(t) {},
              onStop: function onStop(t, e) {},
              onStart: function onStart(t, e) {},
              onDestroy: function onDestroy(t) {}
            }, t.exports = e.default;
          }, function (t, e) {
            "use strict";

            Object.defineProperty(e, "__esModule", {
              value: !0
            });

            var n = function () {
              function t(t, e) {
                for (var n = 0; n < e.length; n++) {
                  var r = e[n];
                  r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
              }

              return function (e, n, r) {
                return n && t(e.prototype, n), r && t(e, r), e;
              };
            }(),
                r = function () {
              function t() {
                !function (t, e) {
                  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t);
              }

              return n(t, [{
                key: "typeHtmlChars",
                value: function value(t, e, n) {
                  if ("html" !== n.contentType) return e;
                  var r = t.substr(e).charAt(0);

                  if ("<" === r || "&" === r) {
                    var s;

                    for (s = "<" === r ? ">" : ";"; t.substr(e + 1).charAt(0) !== s && !(1 + ++e > t.length);) {
                      ;
                    }

                    e++;
                  }

                  return e;
                }
              }, {
                key: "backSpaceHtmlChars",
                value: function value(t, e, n) {
                  if ("html" !== n.contentType) return e;
                  var r = t.substr(e).charAt(0);

                  if (">" === r || ";" === r) {
                    var s;

                    for (s = ">" === r ? "<" : "&"; t.substr(e - 1).charAt(0) !== s && !(--e < 0);) {
                      ;
                    }

                    e--;
                  }

                  return e;
                }
              }]), t;
            }();

            e.default = r;
            var s = new r();
            e.htmlParser = s;
          }]);
        }, t.exports = e();
      },
      787: function _(e) {
        "use strict";

        e.exports = t;
      }
    },
        n = {};

    function r(t) {
      var s = n[t];
      if (void 0 !== s) return s.exports;
      var o = n[t] = {
        exports: {}
      };
      return e[t].call(o.exports, o, o.exports, r), o.exports;
    }

    r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return r.d(e, {
        a: e
      }), e;
    }, r.d = function (t, e) {
      for (var n in e) {
        r.o(e, n) && !r.o(t, n) && Object.defineProperty(t, n, {
          enumerable: !0,
          get: e[n]
        });
      }
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    };
    var s = {};
    return function () {
      "use strict";

      r.r(s), r.d(s, {
        default: function _default() {
          return C;
        }
      });
      var t = r(787),
          e = r.n(t),
          n = r(697),
          o = r.n(n),
          i = r(614),
          a = r.n(i);

      function u(t) {
        return u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, u(t);
      }

      var c = ["style", "typedRef", "stopped", "className"],
          p = ["style", "typedRef", "stopped", "className"],
          l = ["style", "typedRef", "stopped", "className"];

      function f(t, e) {
        if (null == t) return {};

        var n,
            r,
            s = function (t, e) {
          if (null == t) return {};
          var n,
              r,
              s = {},
              o = Object.keys(t);

          for (r = 0; r < o.length; r++) {
            n = o[r], e.indexOf(n) >= 0 || (s[n] = t[n]);
          }

          return s;
        }(t, e);

        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(t);

          for (r = 0; r < o.length; r++) {
            n = o[r], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (s[n] = t[n]);
          }
        }

        return s;
      }

      function y(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }

      function h(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      function d(t, e) {
        return d = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, d(t, e);
      }

      function m(t, e) {
        if (e && ("object" === u(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return g(t);
      }

      function g(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }

      function b(t) {
        return b = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, b(t);
      }

      function v(t, e, n) {
        return e in t ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n, t;
      }

      var k = function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(t, "prototype", {
            writable: !1
          }), e && d(t, e);
        }(u, t);
        var n,
            r,
            s,
            o,
            i = (s = u, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }(), function () {
          var t,
              e = b(s);

          if (o) {
            var n = b(this).constructor;
            t = Reflect.construct(e, arguments, n);
          } else t = e.apply(this, arguments);

          return m(this, t);
        });

        function u() {
          var t;
          y(this, u);

          for (var n = arguments.length, r = new Array(n), s = 0; s < n; s++) {
            r[s] = arguments[s];
          }

          return v(g(t = i.call.apply(i, [this].concat(r))), "rootElement", e().createRef()), t;
        }

        return n = u, r = [{
          key: "componentDidMount",
          value: function value() {
            var t = this.props,
                e = (t.style, t.typedRef, t.stopped),
                n = (t.className, f(t, c));
            this.constructTyped(n), e && this.typed.stop();
          }
        }, {
          key: "constructTyped",
          value: function value() {
            var t = this,
                e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                n = this.props,
                r = (n.style, n.typedRef, n.stopped, n.className, f(n, p));
            this.typed && this.typed.destroy(), this.typed = new (a())(this.rootElement.current, Object.assign(r, e)), this.props.typedRef && this.props.typedRef(this.typed), this.typed.reConstruct = function (e) {
              t.constructTyped(e);
            };
          }
        }, {
          key: "shouldComponentUpdate",
          value: function value(t) {
            var e = this;

            if (this.props !== t) {
              t.style, t.typedRef, t.stopped, t.className;
              var n = f(t, l);
              return this.typed.options = Object.assign(this.typed.options, n), !Object.keys(t).every(function (n) {
                return !e.props[n] && t[n] ? (e.constructTyped(t), !1) : (e.typed[n] && (e.typed[n] = t[n]), !0);
              }) || this.props.strings.length === t.strings.length || this.constructTyped(t), !0;
            }

            return !1;
          }
        }, {
          key: "render",
          value: function value() {
            var t = this.props,
                n = t.style,
                r = t.className,
                s = t.children,
                o = e().createElement("span", {
              ref: this.rootElement
            });
            return s && (o = e().cloneElement(s, {
              ref: this.rootElement
            })), e().createElement("span", {
              style: n,
              className: r
            }, o);
          }
        }], r && h(n.prototype, r), Object.defineProperty(n, "prototype", {
          writable: !1
        }), u;
      }(t.Component);

      k.propTypes = {
        style: o().object,
        className: o().string,
        children: o().object,
        typedRef: o().func,
        stopped: o().bool,
        strings: o().arrayOf(o().string),
        typeSpeed: o().number,
        startDelay: o().number,
        backSpeed: o().number,
        smartBackspace: o().bool,
        shuffle: o().bool,
        backDelay: o().number,
        fadeOut: o().bool,
        fadeOutClass: o().string,
        fadeOutDelay: o().number,
        loop: o().bool,
        loopCount: o().number,
        showCursor: o().bool,
        cursorChar: o().string,
        autoInsertCss: o().bool,
        attr: o().string,
        bindInputFocusEvents: o().bool,
        contentType: o().oneOf(["html", ""]),
        onComplete: o().func,
        preStringTyped: o().func,
        onStringTyped: o().func,
        onLastStringBackspaced: o().func,
        onTypingPaused: o().func,
        onTypingResumed: o().func,
        onReset: o().func,
        onStop: o().func,
        onStart: o().func,
        onDestroy: o().func
      };
      var C = k;
    }(), s;
  }();
});